import { withNamespace } from 'shared/lib';

export const Title = ({ children }) => {
  return <div className='title-area'>{children}</div>;
};

const Main = () => {
  return <h2 className='header-tit-02'>환자 정보를 확인해 주세요</h2>;
};

const Sub = () => {
  return <span className='sub-tit-01'>입력하신 환자 정보가 정확한지 확인해 주세요.</span>;
};

export default withNamespace(Title, { Main, Sub });
